<template>
  
    <el-container>
     
      <el-main>
       <h1>Price</h1>

       <table>
<thead>
<tr>
<th>free</th>
<th>Catalyst</th>
</tr>
</thead>
<tbody>
<tr>
<td><code>basic</code> mode of mindmap</td>
<td>advanced features in  <code>rich</code> mode of mind map</td>
</tr>
<tr>
<td>most features in <code>rich</code> mode of mindmap</td>
<td>pdf annotate</td>
</tr>
<tr>
<td>list mode</td>
<td>support development</td>
</tr>
<tr>
<td>support mobile and pc</td>
<td>support mobile and pc</td>
</tr>
<tr>
<td>$0</td>
<td>$12 （forever）</td>
</tr>
<tr>
<td></td>
<td><a href="https://www.markmind.net" rel="nofollow">Buy</a></td>
</tr>
</tbody>
</table>

<h4>You can <i>try it for 30 days for free</i>，and you can buy a active code in website , then input it in setting tab</h4>

<h3>How to active mobile version ?</h3>
<ol>
    <li>Open a mindmap</li>
    <li>Input active code in setting tab on pc version</li>
    <li>Restart obsidian,it will auto create mobile active code</li>
    <li>Copy it and paste to your mobile</li>
</ol>



      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'PricePage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
